import { Icon } from "../components/Icon"
import { PaymentTermsNotice } from "../components/PaymentSummary"
import { PayReserveLabel } from "../components/PayReserveLabel"
import { ButtonSpinner } from "../components/StatusMessages"
import { DetailsStep } from "./DetailsStep"
import type { CheckoutViewModel } from "../viewTypes"

type Props = CheckoutViewModel & { product: NonNullable<CheckoutViewModel["product"]> }

export function PaymentStep(inputs: Props) {
    const { walletSectionClass, walletDisabled, expressMountRef, paymentMountRef, billingMountRef, differentBilling, setDifferentBilling, setBillingComplete, instanceId, error, product, payDisabled, confirmPayment, phase, checkoutPreparing } = inputs
    return <section className="ah-panel ah-stage-panel ah-payment-panel">
        <DetailsStep {...inputs} />
        <div className="ah-payment-section-separator" />
        <div className="ah-payment-heading">
            <h2 className="ah-section-title">2. Payment</h2>
            <span className="ah-payment-security"><Icon name="lock" /><span>Secured by</span><img src="/payment-logos/stripe.svg" alt="Stripe" width="38" height="16" /></span>
        </div>
        <div className={walletSectionClass} role="group" aria-label="Express checkout" aria-disabled={walletDisabled}>
            {/* Stripe owns the iframe controls. Inert blocks keyboard and touch as well as pointer input without remounting them. */}
            <div ref={expressMountRef} className="ah-express-element" {...(walletDisabled ? { inert: "" } : {})} />
        </div>
        <div ref={paymentMountRef} className="ah-payment-element" />
        <div className="ah-billing-options">
            <label className="ah-billing-checkbox">
                <input type="checkbox" checked={!differentBilling} disabled={phase === "paying" || phase === "confirming"}
                    aria-controls={`${instanceId}-billing-address`}
                    onChange={(event) => { setBillingComplete(false); setDifferentBilling(!event.target.checked) }} />
                <span>Billing address same as delivery address</span>
            </label>
            {differentBilling && <div id={`${instanceId}-billing-address`} role="group" aria-label="Billing address">
                <div ref={billingMountRef} className="ah-stripe-address" />
            </div>}
        </div>
        {error && <div className="ah-alert ah-error" role="alert">{error}</div>}
        <div className="ah-desktop-payment-actions">
            <button type="button" className="ah-primary-button ah-pay-button" disabled={payDisabled} aria-busy={checkoutPreparing || phase === "paying"} onClick={() => void confirmPayment()}>{checkoutPreparing ? <ButtonSpinner /> : <PayReserveLabel processing={phase === "paying"} />}</button>
            <PaymentTermsNotice termsUrl={product.terms.url} />
        </div>
    </section>
}
